/* Better Days Customs product builder */
(function () {
  'use strict';

  function money(cents, fmt) {
    var n = (cents / 100).toFixed(2);
    var parts = n.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var v = parts.join('.');
    if (fmt && fmt.indexOf('{{') > -1) return fmt.replace(/\{\{\s*\w+\s*\}\}/, v);
    return '$' + v;
  }

  function locCountFromLabel(label) {
    if (!label) return 0;
    var m = String(label).match(/(\d+)/);
    return m ? parseInt(m[1], 10) : 0;
  }

  function swTable(handle) {
    var raw = window.BDC_SW_RAW || '';
    if (!raw) return null;
    var all = raw.split('~');
    for (var i = 0; i < all.length; i++) {
      var p = all[i].indexOf('^');
      if (p > 0 && all[i].slice(0, p) === handle) {
        var out = [];
        var q = all[i].slice(p + 1).split('|');
        for (var j = 0; j < q.length; j++) {
          var b = q[j].lastIndexOf(':');
          var a = q[j].lastIndexOf(':', b - 1);
          if (a < 0 || b < 0) continue;
          out.push({ name: q[j].slice(0, a), sw: q[j].slice(a + 1, b), img: q[j].slice(b + 1) });
        }
        return out;
      }
    }
    return null;
  }

  function init(root) {
    if (!root || root.__bdcInit) return;
    root.__bdcInit = true;

    var dataEl = root.querySelector('[data-bdc-pricing]');
    var cfg = {};
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) { cfg = {}; }

    var fmt = root.getAttribute('data-money-format') || '';
    var handle = root.getAttribute('data-handle') || cfg.handle || '';
    var minQty = parseInt(root.getAttribute('data-min-qty') || '1', 10) || 1;
    var quoteUrl = root.getAttribute('data-quote-url') || '/pages/request-a-quote';
    var tierCodes = (root.getAttribute('data-tier-codes') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);

    var sizes = cfg.sizes || [];
    var breaks = (cfg.breaks || []).map(function (b) { return parseInt(b, 10); });
    var steps = String(cfg.stepPct || '').split(',').map(function (x) { return parseFloat(x) || 0; }).filter(function (x) { return x > 0; });
    function stepAt(i) { return i > 0 ? (steps[i - 1] || 0) : 0; }
    var locPrice = parseFloat(cfg.locationPrice) || 0;

    var vmap = {};
    (cfg.variants || []).forEach(function (v) { vmap[v.s + '||' + locCountFromLabel(v.l)] = v; });

    var qtyInputs = Array.prototype.slice.call(root.querySelectorAll('[data-bdc-size]'));
    var locInputs = Array.prototype.slice.call(root.querySelectorAll('[data-bdc-loc]'));
    var colorWrap = root.querySelector('[data-bdc-colorwrap]');
    var colorMore = root.querySelector('[data-bdc-colormore]');
    var colorName = root.querySelector('[data-bdc-color-name]');
    var viewTabs = root.querySelector('[data-bdc-viewtabs]');
    var galleryImg = root.querySelector('#bdc-gallery-main');
    var summaryThumb = root.querySelector('#bdc-summary-thumb');
    var rowsEl = root.querySelector('[data-bdc-summary-rows]');
    var totalEl = root.querySelector('[data-bdc-total-value]');
    var perEl = root.querySelector('[data-bdc-per-piece]');
    var totalQtyEl = root.querySelector('[data-bdc-total-qty]');
    var minNote = root.querySelector('[data-bdc-min-note]');
    var locSum = root.querySelector('[data-bdc-loc-sum]');
    var headline = root.querySelector('[data-bdc-headline-price]');
    var errEl = root.querySelector('[data-bdc-cta-error]');
    var designLink = root.querySelector('[data-bdc-designlink]');

    var state = { color: null, view: 'f', colors: [], expanded: false };

    function chosenLocations() {
      return locInputs.filter(function (i) { return i.checked; }).map(function (i) { return i.value; });
    }
    function locCount() { return chosenLocations().length; }

    function totalQty() {
      return qtyInputs.reduce(function (t, i) { return t + (parseInt(i.value, 10) || 0); }, 0);
    }

    function tierIndex(qty) {
      var idx = 0;
      for (var i = 0; i < breaks.length; i++) { if (qty >= breaks[i]) idx = i + 1; }
      return idx;
    }
    function tierFactor(qty) {
      return (100 - stepAt(tierIndex(qty))) / 100;
    }

    function variantFor(size, locs) {
      return vmap[size + '||' + locs] || null;
    }

    /* ---------- colours ---------- */

    function renderColors() {
      var table = swTable(handle);
      if (!table || !table.length) {
        if (colorWrap) colorWrap.innerHTML = '<p class="bdc-colors__loading">Colour list unavailable. Tell us the colour you want in the notes.</p>';
        return;
      }
      state.colors = table;
      var html = '';
      for (var i = 0; i < table.length; i++) {
        var c = table[i];
        html += '<button type="button" class="bdc-color' + (i >= 24 ? ' is-extra' : '') + '" data-bdc-colorbtn="' + i + '"' +
                ' title="' + c.name.replace(/"/g, '&quot;') + '" aria-label="' + c.name.replace(/"/g, '&quot;') + '">' +
                '<span class="bdc-color__dot" style="background-image:url(https://cdn.ssactivewear.com/Images/ColorSwatch/' + c.sw + '_fm.jpg)"></span>' +
                '<span class="bdc-color__tip" aria-hidden="true">' + c.name + '</span></button>';
      }
      colorWrap.innerHTML = html;
      colorWrap.classList.toggle('has-extra', table.length > 24);
      if (colorMore) colorMore.hidden = table.length <= 24;
      colorWrap.addEventListener('click', function (e) {
        var b = e.target.closest('[data-bdc-colorbtn]');
        if (!b) return;
        pickColor(parseInt(b.getAttribute('data-bdc-colorbtn'), 10));
      });
      pickColor(0);
    }

    function pickColor(i) {
      var c = state.colors[i];
      if (!c) return;
      state.color = c;
      Array.prototype.forEach.call(colorWrap.querySelectorAll('[data-bdc-colorbtn]'), function (b) {
        b.classList.toggle('is-active', parseInt(b.getAttribute('data-bdc-colorbtn'), 10) === i);
      });
      if (colorName) colorName.textContent = c.name;
      if (viewTabs) viewTabs.hidden = false;
      paintGallery();
      if (designLink) {
        designLink.href = '/pages/design?product=' + encodeURIComponent(handle) + '&color=' + encodeURIComponent(c.name);
      }
      recalc();
    }

    function colorImg(view) {
      if (!state.color) return null;
      return 'https://cdn.ssactivewear.com/Images/Color/' + state.color.img + '_' + view + '_fl.jpg';
    }

    function paintGallery() {
      var url = colorImg(state.view);
      if (!url) return;
      if (galleryImg) {
        galleryImg.removeAttribute('srcset');
        galleryImg.removeAttribute('sizes');
        galleryImg.src = url;
        galleryImg.alt = cfg.title + ' in ' + state.color.name;
      }
      if (summaryThumb) {
        summaryThumb.removeAttribute('srcset');
        summaryThumb.removeAttribute('sizes');
        summaryThumb.src = 'https://cdn.ssactivewear.com/Images/Color/' + state.color.img + '_f_fl.jpg';
      }
    }

    if (viewTabs) {
      viewTabs.addEventListener('click', function (e) {
        var b = e.target.closest('[data-bdc-view]');
        if (!b) return;
        state.view = b.getAttribute('data-bdc-view');
        Array.prototype.forEach.call(viewTabs.querySelectorAll('[data-bdc-view]'), function (x) {
          x.classList.toggle('is-active', x === b);
        });
        paintGallery();
      });
    }

    if (colorMore) {
      colorMore.addEventListener('click', function () {
        state.expanded = !state.expanded;
        colorWrap.classList.toggle('is-open', state.expanded);
        colorMore.textContent = state.expanded ? 'Show fewer colours' : 'Show all colours';
      });
    }

    /* ---------- pricing ---------- */

    function recalc() {
      var locs = locCount();
      var qty = totalQty();
      var factor = tierFactor(qty);
      var tIdx = tierIndex(qty);

      qtyInputs.forEach(function (i) {
        var size = i.getAttribute('data-bdc-size');
        var v = variantFor(size, locs);
        var lbl = root.querySelector('[data-bdc-size-price="' + size.replace(/"/g, '\\"') + '"]');
        if (lbl) lbl.textContent = v ? money(Math.round(v.p * factor), fmt) : '';
      });

      var first = sizes[0];
      for (var t = 0; t <= breaks.length; t++) {
        var el = root.querySelector('[data-bdc-tierprice="' + t + '"]');
        if (!el) continue;
        var v = variantFor(first, locs);
        var f = (100 - stepAt(t)) / 100;
        el.textContent = v ? money(Math.round(v.p * f), fmt) : '';
      }
      Array.prototype.forEach.call(root.querySelectorAll('[data-bdc-tier]'), function (el) {
        el.classList.toggle('is-active', parseInt(el.getAttribute('data-bdc-tier'), 10) === tIdx);
      });

      var garment = 0, printing = 0, missing = false;
      qtyInputs.forEach(function (i) {
        var n = parseInt(i.value, 10) || 0;
        if (!n) return;
        var size = i.getAttribute('data-bdc-size');
        var base = variantFor(size, 0);
        var v = variantFor(size, locs);
        if (!v || !base) { missing = true; return; }
        garment += base.p * n;
        printing += (v.p - base.p) * n;
      });
      var gross = garment + printing;
      var discount = Math.floor(gross * stepAt(tIdx) / 100);
      var total = gross - discount;

      if (totalQtyEl) totalQtyEl.textContent = qty;
      if (minNote) minNote.textContent = qty > 0 && qty < minQty ? 'Minimum ' + minQty + ' pieces' : '';
      if (locSum) {
        locSum.textContent = locs === 0
          ? 'No printing selected. This is a blank garment.'
          : locs + (locs === 1 ? ' location' : ' locations') + ' at ' + money(Math.round(locPrice * 100), fmt) + ' per piece per location.';
      }

      if (rowsEl) {
        var html = '';
        if (qty === 0) {
          html = '<div class="bdc-summary__row bdc-summary__row--muted"><dt>Nothing selected yet</dt><dd>Pick sizes to see your price</dd></div>';
        } else {
          html += '<div class="bdc-summary__row"><dt>Garment ' + qty + (qty === 1 ? ' piece' : ' pieces') + '</dt><dd>' + money(garment, fmt) + '</dd></div>';
          html += '<div class="bdc-summary__row"><dt>Printing ' + (locs === 0 ? 'none' : locs + (locs === 1 ? ' location' : ' locations')) + '</dt><dd>' + money(printing, fmt) + '</dd></div>';
          if (discount > 0) {
            html += '<div class="bdc-summary__row bdc-summary__row--save"><dt>Quantity discount ' + stepAt(tIdx) + '%</dt><dd>&minus;' + money(discount, fmt) + '</dd></div>';
          }
        }
        rowsEl.innerHTML = html;
      }
      if (totalEl) totalEl.textContent = money(total, fmt);
      if (perEl) perEl.textContent = qty > 0 ? money(Math.round(total / qty), fmt) + ' per piece before delivery and tax' : '';
      if (headline) {
        var b0 = variantFor(sizes[0], locs);
        headline.textContent = b0 ? (qty > 0 ? money(Math.round(b0.p * factor), fmt) + ' each' : 'From ' + money(b0.p, fmt)) : 'Request a quote';
      }
      if (errEl && !errEl.hidden) { errEl.hidden = true; errEl.textContent = ''; }
      state.missing = missing;
      state.tIdx = tIdx;
    }

    /* ---------- steppers ---------- */

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-bdc-step]');
      if (!b) return;
      e.preventDefault();
      var input = b.parentNode.querySelector('[data-bdc-size]');
      if (!input) return;
      var d = parseInt(b.getAttribute('data-bdc-step'), 10);
      input.value = Math.max(0, (parseInt(input.value, 10) || 0) + d);
      recalc();
    });
    qtyInputs.forEach(function (i) {
      i.addEventListener('input', recalc);
      i.addEventListener('change', recalc);
    });
    locInputs.forEach(function (i) { i.addEventListener('change', recalc); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-bdc-opt]'), function (i) {
      i.addEventListener('change', recalc);
    });

    /* ---------- size guide ---------- */

    var guide = root.querySelector('[data-bdc-sizeguide]');
    function openGuide() { if (guide) { guide.hidden = false; document.documentElement.style.overflow = 'hidden'; } }
    function closeGuide() { if (guide) { guide.hidden = true; document.documentElement.style.overflow = ''; } }
    Array.prototype.forEach.call(root.querySelectorAll('[data-bdc-sizeguide-open]'), function (b) {
      b.addEventListener('click', openGuide);
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-bdc-sizeguide-close]'), function (b) {
      b.addEventListener('click', closeGuide);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeGuide(); });

    /* ---------- properties ---------- */

    function collectProps() {
      var props = {};
      if (state.color) props['Colour'] = state.color.name;
      var locs = chosenLocations();
      if (locs.length) props['Print locations'] = locs.join(', ');
      Array.prototype.forEach.call(root.querySelectorAll('[data-bdc-opt]'), function (i) {
        if (i.checked) props[i.getAttribute('data-property')] = i.value;
      });
      Array.prototype.forEach.call(root.querySelectorAll('[data-bdc-prop]'), function (i) {
        var v = (i.value || '').trim();
        if (v && v !== 'No personalization') props[i.getAttribute('data-bdc-prop')] = v;
      });
      return props;
    }

    function showErr(msg) {
      if (!errEl) return;
      errEl.textContent = msg;
      errEl.hidden = false;
    }

    function forcesQuote() {
      var q = false;
      Array.prototype.forEach.call(root.querySelectorAll('[data-bdc-opt]'), function (i) {
        if (i.checked && i.getAttribute('data-quote') === 'true') q = true;
      });
      return q;
    }

    function goToQuote() {
      var payload = {
        handle: handle, title: cfg.title, url: cfg.url,
        colour: state.color ? state.color.name : '',
        locations: chosenLocations(),
        sizes: qtyInputs.reduce(function (o, i) {
          var n = parseInt(i.value, 10) || 0;
          if (n) o[i.getAttribute('data-bdc-size')] = n;
          return o;
        }, {}),
        props: collectProps()
      };
      try { sessionStorage.setItem('bdc:config', JSON.stringify(payload)); } catch (e) {}
      window.location.href = quoteUrl;
    }

    function addToCart(blank) {
      var locs = blank ? 0 : locCount();
      var items = [];
      var props = collectProps();
      if (blank) { delete props['Print locations']; props['Decoration'] = 'None, blank garment'; }
      qtyInputs.forEach(function (i) {
        var n = parseInt(i.value, 10) || 0;
        if (!n) return;
        var v = variantFor(i.getAttribute('data-bdc-size'), locs);
        if (!v) return;
        items.push({ id: v.id, quantity: n, properties: props });
      });
      if (!items.length) { showErr('Pick a quantity for at least one size first.'); return; }
      var qty = totalQty();
      if (qty < minQty) { showErr('Minimum order is ' + minQty + ' pieces.'); return; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); });
        return r.json();
      }).then(function () {
        var idx = tierIndex(qty);
        if (idx > 0 && tierCodes[idx - 1]) {
          window.location.href = '/discount/' + encodeURIComponent(tierCodes[idx - 1]) + '?redirect=/cart';
        } else {
          window.location.href = '/cart';
        }
      }).catch(function (err) { showErr(err.message); });
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-bdc-cta]'), function (b) {
      b.addEventListener('click', function () {
        var action = b.getAttribute('data-action');
        if (action === 'quote' || forcesQuote()) { goToQuote(); return; }
        addToCart(action === 'blank');
      });
    });

    /* ---------- boot ---------- */

    if (window.BDC_SW_RAW) {
      renderColors();
    } else if (window.BDC_SW_URL) {
      fetch(window.BDC_SW_URL).then(function (r) { return r.text(); }).then(function (t) {
        window.BDC_SW_RAW = t;
        renderColors();
      }).catch(function () { renderColors(); });
    } else {
      renderColors();
    }
    recalc();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bdc-builder]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
